<div class="row align-middle">
    <div class="small-12 columns text-center">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        <span>Logging In...</span>
    </div>
</div>
